export default __webpack_public_path__ + "static/scale-c0cae1848499ba8b7ee40b56d05e15a1.png";